<template>
  <v-switch
    ref="checkbox"
    class="edn-switch"
    :rules="rules"
    v-model="Value"
    v-bind="$attrs"
    :color="$vuetify.theme.currentTheme.primary"
    v-on="$listeners"
  >
    <template v-if="$attrs.tooltip" v-slot:append>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon size="16" v-on="on" style="cursor: pointer">mdi mdi-information</v-icon>
        </template>
        {{ $attrs.tooltip }}
      </v-tooltip>
    </template>
    <template v-slot:label> 
      <span :style="getLabelStyles">{{ $attrs.label }}</span>
      <span v-if="$attrs.required" class="red--text">*</span> 
    </template>
  </v-switch>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednValue } from './mixins/ednValue'

export default {
  mixins: [ednRequired, ednValue],
  inheritAttrs: false,
  props: {
    invalidMsg: {
      type: String,
      default: () => 'Merci de bien vouloir activer le switch',
    },
    value: {
      type: Boolean,
      default: false,
    },
    labelStyles: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    /** CSS styles for the label */
    getLabelStyles: function(){
      return this.labelStyles
    }
  },
}
</script>
<style>
.edn-switch .v-input__append-outer {
  margin-bottom: 3px;
  margin-top: 3px;
}
</style>
